import React, { useState } from "react";

import RenderTemplate from "./core/RenderTemplate";
import Tab, { TabOption } from "./reusable/Tab";
import Label from "./Label/Label";

const bgModules = {
    color: ["style/backgroundColor"],
    gradient: ["style/backgroundImage/gradient"],
    image: [
        "style/backgroundImage/image",
        {
            path: "style/asdfasdf",
            content: {
                onValue: true,
                onLabel: "ON",
                offValue: false,
                offLabel: "OFF",
                template: "Switch",
                defaultValue: false,
                label: "Parallax / Fixed Background"
            }
        },
        "style/backgroundSize",
        "style/backgroundPosition",
        "style/backgroundRepeat",
        "style/backgroundBlendMode",
        "attr/__class__overlayType",
        {
            path: "pseudoClass/before/backgroundColor",
            conditions: ["attr/__class__overlayType", "===", "color-overlay"],
            content: {
                template: "ColorPicker"
            }
        },
        {
            path: "pseudoClass/before/backgroundGradient",
            conditions: [
                "attr/__class__overlayType",
                "===",
                "gradient-overlay"
            ],
            content: {
                template: "BackgroundGradient"
            }
        }
    ],
    video: [],
    special: []
};

const BackgroundStyleGroup = props => {
    const [activeState, setState] = useState("color");
    const { currentEditItem, handleChange } = props;

    const handleCategory = ({ value }) => setState(value);

    return (
        <div>
            <Label>Background Styles</Label>
            <Tab
                type="boxed"
                selected={activeState}
                onSelect={handleCategory}
                style={{ marginBottom: "20px" }}
            >
                <TabOption value="color">Color</TabOption>
                <TabOption value="gradient">Gradient</TabOption>
                <TabOption value="image">Image</TabOption>
                <TabOption
                    title="this options is disabled"
                    isDisabled={true}
                    value="video"
                >
                    Video
                </TabOption>
                <TabOption
                    title="this options is disabled"
                    isDisabled={true}
                    value="special"
                >
                    Special
                </TabOption>
            </Tab>
            {bgModules[activeState].map((mod, index) => (
                <RenderTemplate
                    key={index}
                    module={mod}
                    handleChange={handleChange}
                    currentEditItem={currentEditItem}
                />
            ))}
        </div>
    );
};
export default React.memo(BackgroundStyleGroup);
